var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.driveFileId)?_c('button',{staticClass:"iconButton download sheetDownloadButton",attrs:{"title":_vm.$t('receiptMatcher.download')},on:{"click":_vm.download}},[_c('DownloadIcon')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }